export const regexPatterns = {
  email: /^[a-zA-Z0-9]{1}[a-zA-Z0-9-.\\\\\\\\-_+]*@[a-zA-Z]{1}[a-zA-Z0-9.-]*[.][a-zA-Z]{2,}$/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/,
  phone: /^[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/,
  onlyNumbers: /^[0-9]{1,100}$/,
};
